<mat-checkbox *ngIf="params[visibleDataFieldValue] !== params.node.data[params[visibleDataField]]"
  [(ngModel)]="params.node.data[params[paramField]]"
  color="primary"
  (change)="sendCheckboxChangeEventToComponent()">
</mat-checkbox>